import React from 'react';
import { FileText } from 'lucide-react';

const IATest1CardWidget = ({ iaTest1 }) => {
  if (!iaTest1) {
    return <p className="text-center py-4 text-gray-500">No IA Test 1 data</p>;
  }

  const totalMarks = Object.values(iaTest1).reduce((sum, val) => sum + (parseFloat(val) || 0), 0);
  const avgMarks = (totalMarks / Object.keys(iaTest1).length).toFixed(2);

  return (
    <div>
      <div className="text-4xl font-bold text-gray-900 mb-2">{avgMarks}</div>
      <p className="text-sm text-gray-600 mb-4">Average Marks</p>
      <button className="w-full flex items-center justify-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
        <FileText className="w-4 h-4" />
        <span>View Report</span>
      </button>
    </div>
  );
};

export default IATest1CardWidget;